<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { handleNavColor } from "@/plugins/handleNavColor";
export default {
  name: "app",
  data() {
    return {
      offlineMsg: null,
    };
  },
  created() {
    const vm = this;
    if (navigator.onLine) {
      window.addEventListener("online", function() {
        // console.log("online");
        vm.offlineMsg.close();
        vm.$message({
          message: vm.$t("LAYOUT.MSG_RECONNECT"),
          center: true,
          iconClass: "el-icon-circle-check",
          customClass: "msg msg-success",
        });
        vm.$store.commit("clientChat/setInternetState", "online");
        // AP-12932 SignalR 未斷線時不會重連，網路恢復也要補送
        vm.$store.dispatch("clientChat/flushOfflineMessages");
        handleNavColor(true);
      });
      window.addEventListener("offline", function() {
        // console.log("offline");
        vm.setOfflineMsg();
        vm.$store.commit("clientChat/setInternetState", "offline");
      });
    } else {
      vm.$router.push("/login");
      vm.$store.dispatch("account/logout");
      vm.setOfflineMsg();
    }
  },
  methods: {
    setOfflineMsg() {
      this.offlineMsg = this.$message({
        message: this.$t("LAYOUT.MSG_OFFLINE"),
        center: true,
        iconClass: "el-icon-error",
        customClass: "msg msg-error",
        showClose: true,
        duration: 0,
      });
      handleNavColor(false);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/all.scss";
#app {
  width: 100%;
  min-width: 1080px;
}
</style>
